module.exports = __webpack_public_path__ + "static/media/histoty_nghiem_thu.c4c4e1cb.png";